import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-canary',
  templateUrl: './canary.component.html',
  styleUrls: ['./canary.component.css']
})
export class CanaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
